import { useLocation, useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { Formik } from 'formik';
import Button from '../components/Button';
import { Field, FieldInput, FieldLabel } from '../components/Field';
import { Modal, ModalExit, ModalName, ModalPart } from '../components/Modal';
import { useToast } from '../components/Toast';
import { createSpaceCache } from '../utilities/cache';
import { CREATE_SPACE } from '../utilities/mutations';

const NewSpaceModal = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const toast = useToast();
  const [createSpace] = useMutation(CREATE_SPACE);

  if (!localStorage.getItem('token')) {
    navigate('/login', { state: { from: location }, replace: true });
  }

  const close = () => {
    if (location.state?.inApp) {
      navigate(-1);
    } else {
      navigate('/login');
    }
  };

  return (
    <Modal onClose={() => close()}>
      <ModalExit />
      <ModalName>New space</ModalName>
      <Formik
        initialValues={{ name: '', slug: '' }}
        onSubmit={async (values) => {
          try {
            await createSpace({
              variables: { name: values.name, slug: values.slug },
              update: (cache, { data: { createSpace } }) =>
                createSpaceCache(cache, createSpace),
            });
          } catch (error) {
            toast({ children: error.message });

            return;
          }

          toast({ children: 'Space created' });
          navigate(`/s/${values.slug}`);
        }}
      >
        {({ values, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <ModalPart>
              <Field>
                <FieldLabel>Name</FieldLabel>
                <FieldInput
                  type="text"
                  name="name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                  data-autofocus
                />
              </Field>
              <Field>
                <FieldLabel>Slug</FieldLabel>
                <FieldInput
                  type="text"
                  name="slug"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.slug}
                />
              </Field>
            </ModalPart>
            <ModalPart>
              <Button
                type="submit"
                disabled={isSubmitting}
                isPrimary
                isExtended
              >
                Create
              </Button>
            </ModalPart>
          </form>
        )}
      </Formik>
    </Modal>
  );
};

export default NewSpaceModal;
